<template>
  <base-modal :action-required="true" @update:state="childEmits">
    <template #modal-content>
      <div class="base-model__content location-modal">
        <div class="base-model__header"></div>
        <img
          v-if="!queryLocation"
          class="base-model__header-img"
          alt="A globe"
          :src="planetIcon"
        />
        <div class="base-model__body">
          <div v-if="!queryLocation">
            <p class="heading-h3 text--bold location-modal__desc">
              Loading available destinations...
            </p>
          </div>
          <div v-else>
            <p class="heading-h3 text--bold display--flex items-center">
              We couldn’t find a nearby airport to you.
            </p>
            <p class="heading-h6 text--bold text-KQ-Grey1">
              Please select from our available departure airports
            </p>
            <airport-lookup
              v-model:airport-from="airportFrom"
              :show-to="false"
              :hideNearby="hideNearby"
              :is-planner="true"
            ></airport-lookup>
          </div>
        </div>
        <div v-if="queryLocation" class="base-model__footer">
          <div>
            <button
              :disabled="locationSelected"
              class="button button--primary"
              :onClick="
                () => {
                  setFromAirport(airportFrom);
                }
              "
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script setup>
import { provide, ref, defineProps, watch, onMounted } from 'vue';
import BaseModal from '../BaseModal/BaseModal.vue';
import AirportLookup from '../AirportLookup/AirportLookup.vue';
import planetIcon from '../../images/planet.svg';
import optiClient from '../../services/api';

const emit = defineEmits(['close:modal', 'airport-selected']);
const isOpen = ref(false);
const locationSelected = ref(false);
const queryLocation = ref(false);
const hideNearby = ref(false);
const airportFrom = ref(null);

provide('injectedIsOpen', isOpen);
const props = defineProps({
  valueUpdate: {
    type: Function,
    default: () => {},
  },
  formValues: {
    type: Object,
    default: () => {
      return {};
    },
  },
  airportsLoaded: {
    type: Boolean,
    default: false,
  },
  nearbyAirport: {
    type: Object,
    default: null,
  },
});

const fetchAirport = async () => {
  try {
    const res = await optiClient.planner.getApiV1PlannerAirportsNearby();
    if (res?.data?.[0]) {
      if (res.data[0]?.[0]?.routePlannerIsActive === true) {
        emit('airport-selected', res.data[0][0]);
        closeModal();
      } else {
        queryLocation.value = true;
      }
    } else {
      queryLocation.value = true;
    }
  } catch (error) {
    console.log(error);
  }
};

const closeModal = () => {
  isOpen.value = false;
};
const setFromAirport = (airport) => {
  emit('airport-selected', airport);
  closeModal();
};

const childEmits = (value) => {
  if (value === 'isClosed') {
    closeModal();
  }
};

onMounted(() => {
  isOpen.value = true;
  fetchAirport();
});
</script>
